import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReset = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#38539A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.2773 19.125H23.0938C22.7422 19.125 22.4258 18.9492 22.2852 18.6328C22.1797 18.3164 22.25 17.9297 22.4961 17.6836L23.9375 16.2422C21.7227 14.0977 18.207 14.0977 15.9922 16.2773C13.8125 18.4922 13.8125 22.043 15.9922 24.2578C18.207 26.4375 21.7578 26.4375 23.9727 24.2578C24.3945 23.8008 25.0977 23.8008 25.5547 24.2578C25.9766 24.6797 25.9766 25.3828 25.5547 25.8398C22.4609 28.8984 17.5039 28.8984 14.4102 25.8398C11.3516 22.7461 11.3516 17.7891 14.4102 14.6953C17.4688 11.6367 22.4258 11.6367 25.5195 14.6602L26.9961 13.1836C27.207 12.9727 27.5938 12.9023 27.9102 13.0078C28.2266 13.1484 28.4375 13.4648 28.4375 13.7812V18.2812C28.4375 18.7734 28.0508 19.125 27.5938 19.125H27.2773Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgReset);
export { ForwardRef as ReactComponent };
